/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  dispute: ModelRegistry['dispute'];

  onClose: () => void;
}

interface UiProtectionDisputePanelSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

const UiProtectionDisputePanelComponent =
  templateOnly<UiProtectionDisputePanelSignature>();

export default UiProtectionDisputePanelComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::DisputePanel': typeof UiProtectionDisputePanelComponent;
    'ui/protection/dispute-panel': typeof UiProtectionDisputePanelComponent;
  }
}
